import React from "react";

import AdPerformanceSection from "./AdPerformanceSection";
import ImageIQSection from "./ImageIQSection";
import LandingPage from "./LandingPage";
import PulseIQSection from "./PulseIQSection";
import StoryIQSection from "./StoryIQSection";
import StoryLensIntro from "./StoryLensIntro";
import VideoIQSection from "./VideoIQSection";
import GetStartedContact from "./GetStartedContact";
import ContentMonetizationExact from "./ContentMonetizationExact";

export default function Home() {
  return (
    <div className="w-full space-y-[100px] px-5 sm:px-8 lg:px-12">
      <LandingPage />
      <StoryLensIntro />
      <AdPerformanceSection />
      <ContentMonetizationExact />
      <VideoIQSection />
      <StoryIQSection />
      <PulseIQSection />
      <ImageIQSection />
      <GetStartedContact />
    </div>
  );
}
